import React, { Fragment, useContext, useEffect } from 'react';
import TouchItem from './TouchItem';
import Spinner from '../layout/Spinner';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import TouchesContext from '../../context/touches/touchesContext';

const Touches = () => {
  const touchesContext = useContext(TouchesContext);

  const { touches, filtered, getTouches, loading } = touchesContext;

  useEffect(() => {
    getTouches();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div style={{ height: '90vh', overflow: 'auto' }}>
        {touches !== null && !loading ? (
          <TransitionGroup>
            {filtered !== null
              ? filtered.map(touch => (
                  <CSSTransition key={touch.id} timeout={500} classNames='item'>
                    <TouchItem touch={touch} />
                  </CSSTransition>
                ))
              : touches.map(touch => (
                  <CSSTransition key={touch.id} timeout={500} classNames='item'>
                    <TouchItem touch={touch} />
                  </CSSTransition>
                ))}
          </TransitionGroup>
        ) : (
          <Spinner />
        )}
      </div>
    </Fragment>
  );
};

export default Touches;
